var map = {
	"./deactive-comprehensive.png": "d519",
	"./deactive-data-analysis.png": "b497",
	"./deactive-equipment.png": "9422",
	"./deactive-home.png": "b70a",
	"./deactive-log.png": "f2d0",
	"./deactive-production.png": "590e",
	"./deactive-task.png": "7c2a",
	"./deactive-warning.png": "1df7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79ed";